export const referenceData = [
  {
    id: 1,
    title: "Заявление на регистрацию МС, физическое лицо",
    url: "boat-card-app/1",
  },
  {
    id: 2,
    title: "Заявление на регистрацию МС, юридическое лицо",
    url: "boat-card-app/2",
  },
  {
    id: 3,
    title: "Заявление на внесение изменений МС, физическое лицо",
    titlePage: "Заявление на изменение сведений в судовую книгу, физическое лицо",
    url: "boat-card-modif/1",
  },
  {
    id: 4,
    title: "Заявление на внесение изменений МС, юридическое лицо",
    titlePage: "Заявление на изменение сведений в судовую книгу, юридическое лицо",
    url: "boat-card-modif/2",
  },
  {
    id: 5,
    title: "Заявление на техосвидетельствование, физическое лицо",
    url: "boat-to/1",
  },
  {
    id: 6,
    title: "Заявление на техосвидетельствование, юридическое лицо",
    url: "boat-to/2",
  },
  {
    id: 7,
    title: "Заявление о выдаче дубликата судового билета, физическое лицо",
    url: "boat-driving-license-duplicate/1",
  },
  {
    id: 8,
    title: "Заявление на предоставление информации, физическое лицо",
    url: "boat-info/1",
  },
  {
    id: 9,
    title: "Заявление на предоставление информации, юридическое лицо",
    url: "boat-info/2",
  },
  {
    id: 10,
    title: "Заявление на обучение",
    url: "training-app",
  },
  {
    id: 11,
    title: "Заявление на проверку знаний",
    url: "training-check-app",
  },
  {
    id: 12,
    title: "Заявление на выдачу республиканского удостоверения",
    url: "boat-driving-license-app/1",
  },
  {
    id: 13,
    title: "Заявление на выдачу международного удостоверения",
    url: "boat-driving-license-app/2",
  },
  {
    id: 14,
    title: "Заявление на обмен республиканского удостоверения",
    url: "boat-driving-license-exchange/1",
  },
  {
    id: 15,
    title: "Заявление на обмен международного удостоверения",
    url: "boat-driving-license-exchange/2",
  },
  {
    id: 16,
    title: "Заявление на выдачу дубликата республиканского удостоверения",
    url: "boat-driving-license-duplicate-app/1",
  },
  {
    id: 17,
    title: "Заявление на выдачу дубликата международного удостоверения",
    url: "boat-driving-license-duplicate-app/2",
  },
];
